import http from 'hub-http/clients/apiClient';
export const SKILLS_CATEGORIES_URL = 'conversations-assignments/v1/skills/categories';
export const createCategory = ({
  category,
  categoryLabel,
  skills
}) => http.post(SKILLS_CATEGORIES_URL, {
  data: {
    categoryLabel,
    categoryName: category,
    options: skills
  }
});
export const fetchAllCategories = () => http.get(`${SKILLS_CATEGORIES_URL}/all`);
export const fetchCategory = ({
  category
}) => http.get(`${SKILLS_CATEGORIES_URL}/${category}`);
export const updateCategory = ({
  label,
  name
}) => http.patch(`${SKILLS_CATEGORIES_URL}/${name}`, {
  data: {
    categoryLabel: label
  }
});